import dayjs from 'dayjs';
import Request from 'commons/libs/requests';
import { ScheduleType } from 'components/schedule/ScheduleType';

export async function createMeeting(schedule: ScheduleType) {
  return (
    await Request.post('/api-patients/meetings/', {
      doctor_amelia_id: schedule.meeting.doctorID,
      start_date: dayjs(schedule.meeting.date).format(),
      rdv_type: schedule.type,
      hasCMU: schedule.hasCMU,
      service_id: schedule.serviceID,
    })
  ).data;
}

export async function updateMeeting(
  id: string | undefined,
  date: string,
  serviceID: string,
) {
  return (
    await Request.patch(`/api-patients/meetings/${id}/`, {
      start_date: dayjs(date).format(),
      service_id: serviceID,
    })
  ).data;
}

export async function deleteMeeting(id: string, reason: string) {
  return (
    await Request.delete(
      `/api-patients/meetings/${id}/?reason=${encodeURI(reason)}`,
    )
  ).data;
}

let getMeetingsController: AbortController;

export async function getMeetings(
  params: URLSearchParams,
  cancelPrevious: boolean = true,
) {
  if (cancelPrevious) {
    if (getMeetingsController?.abort) {
      getMeetingsController.abort();
    }

    getMeetingsController = new AbortController();
  }

  const response = await Request.get('/api-patients/meetings/', {
    params,
    signal: getMeetingsController.signal,
  });
  return response.data;
}
